import { render, staticRenderFns } from "./host-web-marathon.vue?vue&type=template&id=38d92fdc&scoped=true&"
import script from "./host-web-marathon.vue?vue&type=script&lang=js&"
export * from "./host-web-marathon.vue?vue&type=script&lang=js&"
import style0 from "./host-web-marathon.vue?vue&type=style&index=0&id=38d92fdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d92fdc",
  null
  
)

export default component.exports